/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./adyen-payment.component";
import * as i2 from "../../services/customer.service";
import * as i3 from "../../services/adyen-payment.service";
import * as i4 from "../../../shared/services/cache.service";
import * as i5 from "../../../shared/services/enrollment-common.service";
var styles_AdyenPaymentComponent = [];
var RenderType_AdyenPaymentComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AdyenPaymentComponent, data: {} });
export { RenderType_AdyenPaymentComponent as RenderType_AdyenPaymentComponent };
export function View_AdyenPaymentComponent_0(_l) { return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { hook: 0 }), (_l()(), i0.ɵeld(1, 0, [[1, 0], ["hook", 1]], null, 0, "div", [["class", "payment"]], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["\n"]))], null, null); }
export function View_AdyenPaymentComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-adyen-payment", [], null, null, null, View_AdyenPaymentComponent_0, RenderType_AdyenPaymentComponent)), i0.ɵdid(1, 114688, null, 0, i1.AdyenPaymentComponent, [i2.CustomerService, i3.AdyenPaymentService, i4.CacheService, i5.EnrollmentCommonService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AdyenPaymentComponentNgFactory = i0.ɵccf("app-adyen-payment", i1.AdyenPaymentComponent, View_AdyenPaymentComponent_Host_0, { adyenPaymentComponentSettings: "adyenPaymentComponentSettings", orderType: "orderType", sessionGuid: "sessionGuid" }, {}, []);
export { AdyenPaymentComponentNgFactory as AdyenPaymentComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/payments/adyen-payment.component.ngfactory.js.pre-build-optimizer.js